// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content___hjqfO"};